<template>
  <div class="modal trader-info right fade"  :class="{
  clientcolumnoption: moduleName === 'CLIENT',
  black: moduleName === 'CLIENT'
}" id="trader-info" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md " role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Column options</h5>
          <button type="button" class="close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <span style="margin-left: 12px; padding: 10px;">
          Utilize checkboxes to add or remove columns. To rearrange the column order, simply drag and drop a field.
        </span>
        <div class="modal-body" style="padding: 25px;">
          <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt="" /></div>

          <b-tabs>
            <b-tab title="Columns" active>
              <div class="d-flex justify-content-between" style="padding: 10px;">
                <div>
                  <!-- <input type="checkbox" v-model="selectAll" @change="selectAllColumns">
                    <label>Select All</label> -->
                </div>
                <div>
                  <button @click="resetColumns" class="btn btn-sm btn-secondary">Reset</button>
                </div>
              </div>


              <div class="list-group list-group-light">
                <draggable class="list-group" tag="ul" v-model="columnHeaders" v-bind="dragOptions"
                  @start="isDragging = true" @end="isDragging = false">
                  <transition-group type="transition" name="flip-list">
                    <li class="list-group-item" v-for="(element, index) in columnHeaders" :key="'column' + index">
                      <input v-show="!element.default" class="form-check-input" type="checkbox"
                        v-bind:id="'checkboxExample' + element.name" v-bind:name="'checkboxExample' + element.name"
                        v-model="element.selected" />
                      <label class="form-check-label" for="checkboxExample1">{{ element.column === 'SP_RATING' ? 'S&P RATING' : element.column.replace(/_/g, ' ') }}</label>
                      <i data-v-3eb58570="" class="fas fa-grip-vertical"
                        style=" visibility: hidden; position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: grab;"></i>
                    </li>
                  </transition-group>
                </draggable>
              </div>
            </b-tab>
            <b-tab title="Sorting">
              <form class="mt-4">
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="inputEmail4">
                      COLUMN
                    </label>
                    <select class="form-control cursor-pointer" v-model="sortColumn">
                      <option v-for="header in columnHeaders.filter(column => column.sortable)" :key="header.key"
                        :value="header.column">
                        {{ header.column === 'SP_RATING' ? 'S&P RATING' : header.column.replace(/_/g, ' ') }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-5">
                    <label for="inputEmail4">
                      SORT ORDER
                    </label>
                    <select class="form-control cursor-pointer" v-model="sortOrder">
                      <option value="ASC">ASC</option>
                      <option value="DESC">DESC</option>
                    </select>
                  </div>
                  <div class="form-group col-md-2 mt-2">
                    <button :disabled="!sortColumn || !sortOrder" type="button" class="btn btn-success btn-sm mt-4" @click="addSortOrder()">ADD</button>
                  </div>
                </div>
                  <hr>
                <div class="form-row" v-for="(element, index) in columnSorts" :key="'column' + index">
                  <div class="form-group col-md-5">
                    <!-- <label for="inputEmail4">
                      COLUMN
                    </label> -->
                    <select class="form-control cursor-pointer" v-model="element.sortColumn">
                      <option v-for="header in columnHeaders.filter(column => column.sortable)" :key="header.key"
                        :value="header.column">
                        {{ header.column}}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-5">
                    <!-- <label for="inputEmail4">
                      SORT ORDER
                    </label> -->
                    <select class="form-control cursor-pointer" v-model="element.sortOrder">
                      <option value="ASC">ASC</option>
                      <option value="DESC">DESC</option>
                    </select>
                  </div>
                  <div class="form-group col-md-2">
                    <a class="text-red cursor-pointer" @click="deleteSort(index)"><i  style="margin-top: 7px;" class="fa fa-trash"></i></a>
                    <!-- <button type="button" class="btn btn-danger btn-sm mt-4" @click="addSortOrder()">DELETE</button> -->
                  </div>
                </div>
              </form>
            </b-tab>
          </b-tabs>

        </div>
        <div class="modal-footer bid">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">Close</button>
          <button type="button" class="btn btn-primary" @click="save()">APPLY</button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import config from "@/config";
import authService from "@/authService";
export default {
  name: 'Columnoptions',
  components: {
    draggable
  },
  props: [
    'moduleName'
  ],
  data() {
    return {
      columnHeaders: [],
      enabled: true,
      dragging: false,
      loading: false,
      columnSorts: [],
      sortColumn: "",
      sortOrder: ""

    };
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    }
  },

  methods: {
    deleteSort(index){
      this.columnSorts.splice(index,1)
    },
    addSortOrder(){
      const hasItem = this.columnSorts.some(item => item.sortColumn === this.sortColumn);
      if(hasItem){
        this.$alert("Column already added", "", "error");

      }else{
        let sortData = {
          sortColumn : this.sortColumn,
          sortOrder : this.sortOrder,
          order : 1
        }
        this.columnSorts.push(sortData);
        this.sortColumn = "";
        this.sortOrder = "";
        console.log(this.columnSorts)
      }

    },
    selectAllColumns() {

    },
    resetColumns() {
      var message = `Are you sure you want to reset the columns?`;
      this.$confirm(message, "", "question", { confirmButtonText: "YES", cancelButtonText: "NO" }).then(() => {
        console.log(this.columnHeaders)
        this.columnHeaders = this.columnHeaders.map(column => {
        column.selected = false; // Set selected to false
        return column;
      }).sort((a, b) => a.defaultorder - b.defaultorder);
      });

    },
    save() {
      console.log(this.columnHeaders)
      this.loading = true;
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let data = {
        "userId": authService.getUser().id,
        "columnSettings": {
          "columnInfos": this.columnHeaders,
          "columnSorts": this.columnSorts
        }
      }
      this.$http
        .post(
          config.baseUrlAutoBidder +
          "/offering-feed/column-setting", data,
          auth
        )
        .then(() => {
          this.$emit('close');
        })
        .catch((e) => {
          console.log(e);
        });
      // const selectedHeaders = this.columnHeaders.filter(header => header.isSelected === true);
      // this.$emit('close');
      // let columnData = {};
      // columnData.selectedHeaders = selectedHeaders;
      // columnData.sortColumn = this.sortColumn;
      // columnData.sortOrder = this.sortOrder;
      // this.$emit('applyColumn', columnData);
    },
    getSavedColumnOptions() {
      this.loading = true;
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlAutoBidder +
          "/offering-feed/column-setting?userId=" +
          authService.getUser().id,
          auth
        )
        .then(result => {
          this.loading = false;
          this.columnHeaders = result.data.columnInfos;
          this.columnSorts = result.data.columnSorts;

        })
    },

  },
  mounted() {
    this.getSavedColumnOptions();
    console.log(this.moduleName)
    // const remainingColumns = this.columnHeaders.filter(item => !this.selectedColumnHeaders.some(saved => saved.key === item.key));



    // console.log(this.selectedColumnHeaders)
    // if(remainingColumns && remainingColumns.length ){
    //   this.columnHeaders = this.selectedColumnHeaders.concat(remainingColumns);
    // }

    // if(remainingColumns && !remainingColumns.length){
    //   this.columnHeaders = this.selectedColumnHeaders
    // }

    // this.selectedColumnHeaders.forEach((header) => {
    //   this.columnHeaders.forEach((columnName) => {
    //     if(header.name == columnName.name)  columnName.isSelected = true;
    //   })
    // })





  }
};
</script>
<style scoped>
.list-group-item {
  text-align: left;
  text-transform: uppercase;
}

.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
  padding: 0.3rem 1.9rem
}

.list-group-item i {
  cursor: pointer;
  color: #525f7f
}

li.list-group-item:hover {
  background-color: #f5f5f5;
  /* Change this color to your desired highlight color */

}

li.list-group-item:hover i {
  visibility: visible !important;
}

.list-group {
  overflow-y: scroll;
  max-height: 525px;
}
button{
  min-width: 5px;
}
</style>